<!-- eslint-disable @angular-eslint/template/cyclomatic-complexity -->
<ng-container *ngIf="activityParameters() as activityParameters">
    <div class="newrow" *ngIf="allowActivate">
        <!-- Buttons if the activity does anything, including activating a cooldown or toggling the activity status. -->
        <ng-container *ngIf="gain && activity.canActivate()">
            <!-- Spell targets if a spell is cast by this activity. -->
            <ng-container *ngIf="activityParameters.activitySpell">
                <app-spellTarget class="newrow vlist" [creature]="creature"
                    [spell]="activityParameters.activitySpell.spell"
                    [phrase]="'Activate' + (activityParameters.maxCharges ? ' (' + (activityParameters.maxCharges - gain.chargesUsed) + ' of ' + activityParameters.maxCharges + ' charges)' : '') + ' and cast'"
                    [gain]="activityParameters.activitySpell.gain" [parentActivityGain]="gain"
                    [parentActivity]="activity" [cannotCast]="activityParameters.disabled"
                    [effectiveSpellLevel]="activityParameters.activitySpell.cast.level || activityParameters.activitySpell.spell.levelreq"
                    [spellCast]="activityParameters.activitySpell.cast" [showDismiss]="true"
                    [dismissPhrase]="activity.sustained ? 'Stop Sustaining' : 'Deactivate'"
                    (castMessage)="onActivate(gain, activity, $event.activated, $event.target)">
                </app-spellTarget>
            </ng-container>
            <!-- Activity targets if no spell is cast. -->
            <ng-container *ngIf="!activityParameters.activitySpell">
                <app-spellTarget class="newrow vlist" [creature]="creature" [activity]="activity"
                    [phrase]="'Activate' + (activityParameters.maxCharges ? ' (' + (activityParameters.maxCharges - gain.chargesUsed) + ' of ' + activityParameters.maxCharges + ' charges)' : '')"
                    [gain]="gain" [cannotCast]="activityParameters.disabled" [effectiveSpellLevel]="character.level"
                    [showDismiss]="true" [dismissPhrase]="activity.sustained ? 'Stop Sustaining' : 'Deactivate'"
                    (castMessage)="onActivate(gain, activity, $event.activated, $event.target)">
                </app-spellTarget>
            </ng-container>
        </ng-container>
        <!-- Activity with no effect, not even toggled. This button literally does nothing. -->
        <ng-container *ngIf="!activity.canActivate()">
            <button class="newrow center-aligned" [ngbTooltip]="'The activity has no automatic effects and no target.'">
                <span>Activate <i class='bi-peace' *ngIf="!isManualMode"></i></span>
            </button>
        </ng-container>
    </div>
    <!-- Unslotted Aeon Stone warning -->
    <button class="newrow list-item" disabled
        *ngIf="isResonant && !(isSubItem || activityParameters.resonantAllowed) && !activityParameters.tooManySlottedAeonStones">
        <strong>
            Slot this item into a Wayfinder to unlock this activation.
        </strong>
    </button>
    <!-- Too many slotted Aeon Stones warning -->
    <div class="newrow list-item problem" *ngIf="activityParameters.tooManySlottedAeonStones">
        You have aeon stones slotted in too many wayfinders. All effects of these aeon stones are disabled.
    </div>
    <ng-container *ngIf="isManualMode && allowActivate">
        <!-- End cooldown and restore charges button in manual mode-->
        <ng-container *ngIf="gain?.activeCooldown">
            <button class="center-aligned" (click)="onManualEndCooldown()">
                <span>End cooldown</span>
            </button>
        </ng-container>
        <!-- Restore charges button in manual mode-->
        <ng-container *ngIf="gain?.chargesUsed">
            <button class="center-aligned" (click)="onManualRestoreCharge()">
                <span>Restore charge</span>
            </button>
        </ng-container>
    </ng-container>
    <div class="newrow left-aligned">
        <app-trait *ngFor="let trait of activity.traits; trackBy:trackers.trackByIndex;" [name]="trait"
            [trait]="traitFromName(trait)">
        </app-trait>
        <app-trait *ngFor="let trait of activity.activationTraits(); trackBy:trackers.trackByIndex;" [name]="trait"
            [trait]="traitFromName(trait)" [extraDescription]="'(This trait was derived from the action components.)'">
        </app-trait>
        <app-tags [creature]="creature" [objectName]="activity.name" [showTraits]=true [showFeats]=true [showItems]=true
            [showActivities]=true [showConditions]=true [showEffects]=true></app-tags>
    </div>
    <div class="newrow list-item" *ngFor="let data of gain?.data; trackBy:trackers.trackByIndex">
        <strong>
            {{data.name}}
        </strong>
        <input class="left-aligned" type="text" [(ngModel)]="data.value">
    </div>
    <ng-container
        *ngFor="let conditionSet of activityConditions(); let conditionSetIndex = index; trackBy:trackers.trackByIndex">
        <div class="newrow list-item left-aligned"
            *ngIf="gain && shownConditionChoice(conditionSet, {tooManySlottedAeonStones: activityParameters.tooManySlottedAeonStones, resonantAllowed: activityParameters.resonantAllowed})">
            <span>{{conditionSet.condition.name}} effect selection:
                <select [(ngModel)]="gain.effectChoices[conditionSetIndex].choice"
                    (ngModelChange)="onEffectChoiceChange()">
                    <option *ngFor="let choice of conditionSet.condition.$choices; trackBy:trackers.trackByIndex;"
                        [ngValue]="choice">
                        {{choice}}
                    </option>
                </select>
            </span>
        </div>
    </ng-container>
    <!-- Additional information coming from other abilities.-->
    <div class="vlist lower">
        <app-activityContent class="vlist fullwidth" [creature]="creature" [activity]="activity" [gain]="gain"
            [allowActivate]="allowActivate" [cooldown]="activityParameters.cooldown"
            [maxCharges]="activityParameters.maxCharges">
        </app-activityContent>
        <!--Only show related feats and conditions if this activity is not currently being shown on another object - that is, if it's allowed to be activated.-->
        <ng-container *ngIf="allowActivate">
            <div class="list-item newrow left-aligned"
                *ngFor="let feat of characterFeatsShowingHintsOnThis(activity.name); trackBy:trackers.trackByIndex;">
                <header class="spellHeader">{{feat.name}}</header>
                <div class="newrow left-aligned">
                    <app-trait *ngFor="let trait of feat.traits; trackBy:trackers.trackByIndex;" [name]="trait"
                        [trait]="traitFromName(trait)">
                    </app-trait>
                </div>
                <div class="newrow left-aligned"
                    *ngFor="let desc of feat.desc.split('\n\n'); trackBy:trackers.trackByIndex;">
                    <app-description class="newrow" [text]="desc"></app-description>
                </div>
            </div>
            <div class="newrow left-aligned"
                *ngFor="let conditionSet of conditionsShowingHintsOnThis(activity.name); trackBy:trackers.trackByIndex;">
                <header class="spellHeader">{{conditionSet.condition.name}}</header>
                <div class="newrow left-aligned"
                    *ngFor="let desc of conditionSet.condition.heightenedText(conditionSet.condition.desc, conditionSet.gain.heightened).split('\n\n'); trackBy:trackers.trackByIndex;">
                    <app-description class="newrow" [text]="desc"></app-description>
                </div>
            </div>
            <div class="list-item newrow left-aligned"
                *ngFor="let activityGain of activitiesShowingHintsOnThis(activity.name); trackBy:trackers.trackByIndex;">
                <header class="spellHeader">
                    {{activityGain.originalActivity.name}}
                    <app-actionIcons *ngIf="activityGain.originalActivity.actions"
                        [actionString]="activityGain.originalActivity.actions">
                    </app-actionIcons>
                    {{(activityGain.originalActivity.activationType) ? activityGain.originalActivity.activationType :
                    ""}}
                </header>
                <app-activity [creature]="creature" [activity]="activityGain.originalActivity" [gain]="activityGain"
                    [allowActivate]=true>
                </app-activity>
            </div>
            <ng-container *ngIf="gain?.name === 'Fused Stance'">
                <div class="list-item newrow left-aligned"
                    *ngFor="let fusedStanceGain of fusedStances(); trackBy:trackers.trackByIndex;">
                    <header class="spellHeader">
                        {{fusedStanceGain.originalActivity.name}}
                        <app-actionIcons *ngIf="fusedStanceGain.originalActivity.actions"
                            [actionString]="fusedStanceGain.originalActivity.actions">
                        </app-actionIcons>
                        {{(fusedStanceGain.originalActivity.activationType) ?
                        fusedStanceGain.originalActivity.activationType : ""}}
                    </header>
                    <app-activity [creature]="creature" [activity]="fusedStanceGain.originalActivity"
                        [gain]="fusedStanceGain" [allowActivate]="false">
                    </app-activity>
                </div>
            </ng-container>
        </ng-container>
    </div>
</ng-container>
